import React, { forwardRef, useEffect, useRef } from "react";
import { graphql, Link } from "gatsby";
import HTMLReactParser, { domToReact } from "html-react-parser";
import Arrow from "../icons/arrow-right-long-sharp-light-2-1.svg";

const BannerTopMenu = forwardRef(({ data }, ref) => {
  const internalRef = useRef();

  useEffect(() => {
    const refEl = (ref || internalRef)?.current;
    if (refEl) {
      const resizeListener = () => {
        const { height } = refEl.getBoundingClientRect();
        const event = new CustomEvent("banner-top-menu-resize", {
          detail: {
            height,
          },
        });
        document.dispatchEvent(event);
      };
      setTimeout(resizeListener, 10);
      window.addEventListener("resize", resizeListener);
      return () => window.removeEventListener("resize", resizeListener);
    }
  }, [ref]);

  return (
    <div ref={ref || internalRef} className="header__top header__top-banner-promo col-12">
      <div className="text-center header__top-banner-promo__text d-flex flex-column flex-md-row justify-content-center mx-md-auto mx-3">
        {data?.btmLink ? (
          <Link
            className="logo__link header__top-banner-promo__link"
            to={data.btmLink}
            target={data.btmTarget ? data.btmTarget : "_self"}
          >
            {HTMLReactParser(data.btmText, {
              replace: (node) => {
                if (node.name === "p" || node.name === "div") {
                  return (
                    <span className="header__top-banner-promo__link-text pr-2">
                      {domToReact(node.children)}
                    </span>
                  );
                }
              },
            })}
            <Arrow className="header__top-banner-promo__link-icon" />
          </Link>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: data.btmText }}></span>
        )}
      </div>
    </div>
  );
});

export default BannerTopMenu;

export const fragment = graphql`
  fragment BannerTopMenuFragment on LiferayBannerTopMenu {
    liferayFields {
      siteId
      articleId
    }
    btmText
    btmLabel
    btmLink
    btmTarget
  }
`;
